module.exports = __webpack_public_path__ + "img/list_4.e85dc326.png";